export const CAMPUS_CONFIRMATION_MESSAGE = 'Are you sure you want to delete this campus.';
export const DEFAULT_CAMPUS_CONFIRMATION_MESSAGE =
  'You are about to delete the default campus. By doing so, the school will be left without a default campus. Do you still want to delete this campus?';
